module.exports = __webpack_public_path__ + "static/image1-d392c0f105fcbaa02e04783acf80a833.jpg";